export default "__VITE_ASSET__BKRfEYKu__"